import store from '@/store';
store.dispatch('initialise', { base_url: window.location.host });
